import React from 'react';
import { connect } from 'react-redux';
// import { ApplicationState } from '../redux/reducers';
import { Route, Redirect } from 'react-router-dom';
// import { isLogin } from '../utils/';

const mapStateToProps = function(state: any) {
  return {
    auth: state.auth,
  }
}

const PrivateRoute = ({component: Component, ...rest}: any) => {
    return (
        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            rest.auth.session ?
                <Component {...props} />
            : <Redirect to="/login" />
        )} />
    );
};

// export default PrivateRoute;

// export default Templates;
export default connect(mapStateToProps, {
  
})(PrivateRoute);

